import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { TextSvg } from './TextSvg'

export const AliTextIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={TextSvg} {...props} />
)
